// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"23580134","774":"23b84004"}[chunkId] + ".chunk.js";
};